module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG98aa84a3e0acde95865db4470e24f13d.98aa84a3.png";